import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import BarChartIcon from '@mui/icons-material/BarChart';
import PhoneAndroid from '@mui/icons-material/PhoneAndroid';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import FontDownload from '@mui/icons-material/FontDownload';
import Download from '@mui/icons-material/Download';

import { Link } from "react-router-dom";

export const mainListItems = (
  <React.Fragment>
    <Link to="/devices" style={{ color: 'inherit', textDecoration: 'inherit'}}>
      <ListItemButton>
        <ListItemIcon>
          <PhoneAndroid />
        </ListItemIcon>
        <ListItemText primary="デバイス管理" />
      </ListItemButton>
    </Link>
    <Link to="/services" style={{ color: 'inherit', textDecoration: 'inherit'}}>
      <ListItemButton>
        <ListItemIcon>
          <BarChartIcon />
        </ListItemIcon>
        <ListItemText primary="サービス管理" />
      </ListItemButton>
    </Link>
    <Link to="/apps" style={{ color: 'inherit', textDecoration: 'inherit'}}>
      <ListItemButton>
        <ListItemIcon>
          <FontDownload />
        </ListItemIcon>
        <ListItemText primary="アプリ管理" />
      </ListItemButton>
    </Link>
    <Link to="/files" style={{ color: 'inherit', textDecoration: 'inherit'}}>
      <ListItemButton>
        <ListItemIcon>
          <InsertDriveFile />
        </ListItemIcon>
        <ListItemText primary="ファイル管理" />
      </ListItemButton>
    </Link>
    <Link to="/logs" style={{ color: 'inherit', textDecoration: 'inherit'}}>
      <ListItemButton>
        <ListItemIcon>
          <Download />
        </ListItemIcon>
        <ListItemText primary="ログ管理" />
      </ListItemButton>
    </Link>
  </React.Fragment>
);
